import { Routes, Route } from 'react-router-dom';

import './App.css';

import Pages from './pages/index';

function App() {
  return (
    <Routes>
        <Route exact path="/" element={<Pages title='Home' />} />
        <Route exact path="/data-scraping" element={<Pages title='Data Scraping I' />} />
    </Routes>
  );
}

export default App;
